import React from 'react';
import { browserHistory } from 'react-router';
import ModuleCustomizationFormContainer from './ModuleCustomizationFormContainer';
import Button from '../../../core/form/Button';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import Card from '../../../core/layout/Card';

const ModuleCustomizationFormScene = () => (
  <div>
    <Breadcrumb
      crumbs={[
        {
          text: 'Create Module Customization',
        },
      ]}
    />
    <Card
      title="Create Module Customization"
      actions={<Button icon="arrow-left" label="Back" type="default" onClick={() => browserHistory.goBack()} />}
    >
      <ModuleCustomizationFormContainer />
    </Card>
  </div>
);

export default ModuleCustomizationFormScene;
